import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { EMRService } from 'app/EMR/EMR.service';
import { SearchNewSurgeryComponent } from 'app/EMR/NewSurgery/add-new-surgery/search-new-surgery/search-new-surgery.component';
import { DashboardService } from 'app/dashboard/dashboard.service';

import { HelplistService } from 'app/helplist.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { DepartmentMasterModel, SurgeryMasterModel } from 'app/masters/models/surgeryMaster.model';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
@Component({
  selector: 'app-surgery-master',
  templateUrl: './surgery-master.component.html',
  styleUrls: ['./surgery-master.component.scss']
})
export class SurgeryMasterComponent implements OnInit {
  SurdepartmentCtrl: FormControl;
  showspinner: any;
  filteredSDeptArray: Observable<any[]>;
  SurcategoryCtrl: FormControl;
  filteredSCategory: Observable<any[]>;
  OpTypeCtrl: FormControl;
  filteredOpTypeArray: Observable<any[]>;
  surgerylistdata: SurgeryMasterModel[] = [];
  surgerylistObject: SurgeryMasterModel = {};
  DepartmentMasterobj: DepartmentMasterModel = {}
  getOPTypeArray: any = [];
  categoryName: string = '';
  cateisActive: boolean = true;
  constructor(public dialog: MatDialog, public helplistservice: HelplistService, public ipdService: IPDService,
    public dashboardservice: DashboardService, public emrservice: EMRService, public branchmatserService: BranchMatserService) {
    this.DepartmentMasterobj.isActive = true;
  }

  ngOnInit(): void {
    this.GetotTypeData();
    this.SurdepartmentControll();
    this.SurCategoryControll(0);
    this.OpTypeControll();
    this.clearsurgerydata();
    this.clearDepartment()
    this.clearDepartmentCate();
  }
  clearDepartmentCate() {
    this.categoryName = '';
    // this.cateisActive = false;
  }
  clearDepartment() {
    // this.DepartmentMasterobj = {};
    this.DepartmentMasterobj.PkSurgeryDeptId = 0;
    this.DepartmentMasterobj.surgeryDeptName = '';
    this.DepartmentMasterobj.isEdit = false;
  }
  clearsurgerydata() {
    this.surgerylistObject = {};
    this.surgerylistObject.pkSurgeryId = 0;
    this.surgerylistObject.surgeryName = '';
    this.surgerylistObject.surgeryDeptName = '';
    this.surgerylistObject.surgeryCatName = '';
    this.surgerylistObject.isEdit = false;
  }
  //Get Opertation Type
  GetotTypeData() {

    this.ipdService.GetOPType().subscribe(item => {
      this.getOPTypeArray = [];
      this.getOPTypeArray = item;
      this.OpTypeControll();

    }, err => {
      if (err.status == 403) {
        this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardservice.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardservice.openSnackBar("API Failed", "OK");
      }
    });
  }
  OpTypeControll() {

    this.OpTypeCtrl = new FormControl();
    this.filteredOpTypeArray = this.OpTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => this.getOPTypeArray.slice())
      );

  }
  getOpTypeobj(e: any) {
    var val = e.option.value;
    this.surgerylistObject.operationTypeName = val.operationTypeName;
    this.surgerylistObject.fK_OperationtypeId = val.pK_OperationTypeId;
  }

  CheckinputOpType(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.surgerylistObject.operationTypeName = '';
      this.surgerylistObject.fK_OperationtypeId = 0;
    }
  }
  SurCategoryControll(pkSurgeryDeptId) {
    this.SurcategoryCtrl = new FormControl();
    if (pkSurgeryDeptId > 0) {
      this.filteredSCategory = this.SurcategoryCtrl.valueChanges
        .pipe(
          startWith(''),
          map(cat => this.helplistservice.categories.filter(obj => obj.fkSurgeryDeptId == pkSurgeryDeptId).slice())
        );
    } else {
      this.filteredSCategory = this.SurcategoryCtrl.valueChanges
        .pipe(
          startWith(''),
          map(cat => this.helplistservice.categories.slice())
        );
    }


  }
  getCategoryobj(e: any) {
    var val = e.option.value;
    this.surgerylistObject.surgeryCatName = val.surgeryCatName;
    this.surgerylistObject.fkSurgeryCatId = val.pkSurgeryCatId;

  }
  SurdepartmentControll() {
    this.SurdepartmentCtrl = new FormControl();
    this.filteredSDeptArray = this.SurdepartmentCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => this.helplistservice.surgery_departments.slice())
      );

  }
  getDepartmentobj(e: any) {
    var val = e.option.value;
    this.surgerylistObject.surgeryDeptName = val.surgeryDeptName;
    this.surgerylistObject.fK_SurgeryDeptId = val.pkSurgeryDeptId;
    this.SurCategoryControll(val.pkSurgeryDeptId)
  }
  CheckinputDept(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.surgerylistObject.fK_SurgeryDeptId = 0;
      this.surgerylistObject.surgeryDeptName = ''
      this.SurCategoryControll(0);
    }
  }

  //Surgery Search Record Modal
  surgerySearchRecordModal() {
    document.getElementById("surgerySearchRecordModal").style.display = "block";
  }
  closeSurgerySearchRecordModal() {
    document.getElementById("surgerySearchRecordModal").style.display = "none";
  }


  //Surgery Search Record Modal
  surgeryDepartmentMasterModal() {
    //  this.clearDepartment()
    document.getElementById("surgeryDepartmentMasterModal").style.display = "block";
  }
  closeSurgeryDepartmentMasterModal() {
    this.clearDepartment()
    document.getElementById("surgeryDepartmentMasterModal").style.display = "none";
  }


  //Surgery Search Record Modal
  surgeryCategoryMasterModal() {

    if (this.surgerylistObject.fK_SurgeryDeptId > 0 && this.surgerylistObject.fK_SurgeryDeptId != null && this.surgerylistObject.fK_SurgeryDeptId != undefined) {
      document.getElementById("surgeryCategoryMasterModal").style.display = "block";
    } else {
      this.dashboardservice.openSnackBar("Select Surgery Department", "ok");
    }

  }
  closeSurgeryCategoryMasterModal() {
    this.clearDepartmentCate();
    document.getElementById("surgeryCategoryMasterModal").style.display = "none";
  }
  openSearchSurgery(): void {
    // this.clearData();
    const dialogRef = this.dialog.open(SearchNewSurgeryComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '90vw',
      width: '90%',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != 0) {
        if (result != null && result != undefined) {
          this.surgerylistObject = {};
          this.surgerylistObject = result;
          this.surgerylistObject.isEdit = true;
        }
      }
    });
  }

  SaveSUrgerydata(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 1000);

    if (this.surgerylistObject.fK_SurgeryDeptId == 0 || this.surgerylistObject.fK_SurgeryDeptId == null || this.surgerylistObject.fK_SurgeryDeptId == undefined) {
      return this.dashboardservice.openSnackBar("Please select surgery Department", "Ok")
    } else if (this.surgerylistObject.fkSurgeryCatId == 0 || this.surgerylistObject.fkSurgeryCatId == null || this.surgerylistObject.fkSurgeryCatId == undefined) {
      return this.dashboardservice.openSnackBar("Please select surgery Category", "Ok")
    } else {
      const selectedDept = this.helplistservice.surgery_departments.find(
        (dept) => dept.surgeryDeptName?.toLowerCase() === this.surgerylistObject.surgeryDeptName?.toLowerCase()
      );

      if (!selectedDept) {
        return this.dashboardservice.openSnackBar("Please select a valid Surgery Department", "Ok");
      }

      const selectedCategory = this.helplistservice.categories.find(
        (category) => category.surgeryCatName?.toLowerCase() === this.surgerylistObject.surgeryCatName?.toLowerCase()
      );

      if (!selectedCategory) {
        return this.dashboardservice.openSnackBar("Please select a valid Surgery Category", "Ok");
      }
      if (this.surgerylistObject.pkSurgeryId == 0) {
        let checkduplicate = this.helplistservice.surgeryList.filter(item => item.surgeryName?.toLowerCase() == this.surgerylistObject.surgeryName.toLowerCase() && item.fkSurgeryCatId == this.surgerylistObject.fkSurgeryCatId && item.fK_SurgeryDeptId == this.surgerylistObject.fK_SurgeryDeptId);
        if (checkduplicate.length > 0) {
          return this.dashboardservice.openSnackBar("Surgery Name Already Exist", "Ok")
        }
      }

      if (!this.surgerylistObject.surgeryName || !this.surgerylistObject.surgeryName.trim()) {
        this.dashboardservice.openSnackBar(" Please Select SurgeryName", "OK");
        return;
      }

      const isValidOpTypeInput = this.surgerylistObject.operationTypeName?.trim();
      if (isValidOpTypeInput) {
        const isValidOpType = this.getOPTypeArray.some(op => op.operationTypeName.toLowerCase() == isValidOpTypeInput.toLowerCase());
      if (!isValidOpType) {
        this.dashboardservice.openSnackBar("Please select a valid Operation Type", "OK");
        return;
      }
      }

      this.showspinner = true;
      this.emrservice.InsertSurgeryMaster(this.surgerylistObject).subscribe(data => {
        if (data['statusCode'] == 1) {
          if (this.surgerylistObject.pkSurgeryId > 0) {
            this.dashboardservice.openSnackBar("Record Updated Successfully", "OK");
          } else {
            this.dashboardservice.openSnackBar("Record Saved Successfully", "OK");
          }
          this.clearsurgerydata();
          this.helplistservice.get_surgerylist(0, 0);
          this.showspinner = false;

        }

      }, err => {
        this.showspinner = false;
        this.dashboardservice.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
      });
    }
  }

  saveDepartment(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 1000);
    if (this.DepartmentMasterobj.surgeryDeptName != '' && this.DepartmentMasterobj.surgeryDeptName != null) {
      const checkdataexistornot = this.helplistservice.surgery_departments.filter(item => item.surgeryDeptName.toLowerCase() == this.DepartmentMasterobj.surgeryDeptName.toLowerCase());
      if (checkdataexistornot.length == 0) {
        let Payloaddata = {
          "SurgeryDepartmentMaster": this.DepartmentMasterobj
        };
        this.branchmatserService.saveDepartmentdata(Payloaddata).subscribe(data => {
          this.helplistservice.get_surgery_departments();
          this.dashboardservice.openSnackBar("Record Saved Successfully", "OK");
          this.closeSurgeryDepartmentMasterModal();
          this.clearDepartment()
        }, err => {
          if (err.status == 403) {
            this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardservice.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardservice.openSnackBar("API Failed", "OK");
          }
        })
      } else {
        this.dashboardservice.openSnackBar("Department Name Already Exist", "OK");
      }
    } else {
      this.dashboardservice.openSnackBar("Enter Department Name", "OK");
    }

  }

  saveDepartmentCategory(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 1000);
    if (this.categoryName != '' && this.categoryName != null) {
      const checkdataexistornot = this.helplistservice.categories.filter(item => item.surgeryCatName.toLowerCase() == this.categoryName.toLowerCase() && item.fkSurgeryDeptId == this.surgerylistObject.fK_SurgeryDeptId);
      if (checkdataexistornot.length == 0) {
        let Payloaddata = {
          "SurgeryCategoryMaster": {
            "pkSurgeryCatId": 0,
            "surgeryCatName": this.categoryName,
            "fkSurgeryDeptId": this.surgerylistObject.fK_SurgeryDeptId,
            "isActive": this.cateisActive,
            "isEdit": false
          }
        };
        this.branchmatserService.saveSurgeryCategorydata(Payloaddata).subscribe(data => {
          this.helplistservice.get_surgery_categories();
          this.dashboardservice.openSnackBar("Record Saved Successfully", "OK");
          this.clearDepartmentCate();
          this.closeSurgeryCategoryMasterModal();
          setTimeout(() => {
            this.SurCategoryControll(this.surgerylistObject.fK_SurgeryDeptId);
          }, 1000);


        }, err => {
          if (err.status == 403) {
            this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
          } else if (err.error.statusCode == 422) {
            this.dashboardservice.openSnackBar(err.error.message, "OK");
          } else {
            this.dashboardservice.openSnackBar("API Failed", "OK");
          }
        })
      } else {
        this.dashboardservice.openSnackBar("Category Name Already Exist", "OK");
      }
    } else {
      this.dashboardservice.openSnackBar("Enter Category Name", "OK");
    }

  }
}
